import { createFileRoute } from "@tanstack/react-router";
import { SettingsLoading } from "../components/settings/shell.tsx";
import { STAFF_TABS, StaffDetail, type StaffTab } from "../components/settings/staff-detail.tsx";
import { useSettingsFranchise } from "../components/settings/use-settings-franchise.ts";

export interface StaffSearch {
  readonly flik?: StaffTab;
}

export const Route = createFileRoute("/installningar/personal_/$resourceId")({
  validateSearch: (search: Record<string, unknown>): StaffSearch =>
    STAFF_TABS.includes(search.flik as StaffTab) ? { flik: search.flik as StaffTab } : {},
  component: Screen,
});

function Screen() {
  const franchise = useSettingsFranchise();
  const { resourceId } = Route.useParams();
  const { flik } = Route.useSearch();
  const navigate = Route.useNavigate();

  if (franchise === null) return <SettingsLoading />;
  return (
    <StaffDetail
      franchise={franchise}
      resourceId={resourceId}
      tab={flik}
      onTabChange={(next) =>
        void navigate({ search: (current) => ({ ...current, flik: next }), replace: true })
      }
    />
  );
}
